/**
 * Redux `userDetails` mirrors API fields; `is_verified` may be boolean or 0/1 from MySQL.
 */
export function isCorporateVerified(userDetails) {
  if (userDetails == null) return false;
  const v = userDetails.is_verified ?? userDetails.isVerified;
  return v === true || v === 1 || v === "1";
}

/** Navigate to profile so user can verify corporate email (OTP flow lives there). */
export const VERIFY_CORPORATE_EMAIL_NAV_STATE = { verifyCorporateEmail: true };
